import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import globalComponents from './global-components'
import PrimeVue from 'primevue/config'
import utils from './utils'
import './libs'

import './assets/sass/app.scss'
import 'primevue/resources/themes/tailwind-light/theme.css'
import 'primeicons/primeicons.css'
// import 'primevue/resources/primevue.css'

const app = createApp(App)
  .use(store)
  .use(router)
  .use(PrimeVue, {
    dateFormat: 'yy-mm-dd'
  })

globalComponents(app)
utils(app)

app.mount('#app')
